export enum AudioEnum {
  INNER_VOICES = 'inner-voices',
  MOON_CLOUD = 'moon-cloud',
  PALM_TREE = 'palm-tree',
  TIME_TRAVEL = 'time-travel',
  NONE = 'none',
}
